import { render } from "./V6StyleBottom.vue?vue&type=template&id=5a8ddfdf&scoped=true"
import script from "./V6StyleBottom.vue?vue&type=script&lang=js"
export * from "./V6StyleBottom.vue?vue&type=script&lang=js"

import "./V6StyleBottom.vue?vue&type=style&index=0&id=5a8ddfdf&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a8ddfdf"]])

export default __exports__